/** Existing organization properties eligible for an explicitly authenticated Shopify store. */
import * as z from 'zod';
import { projectSourcesGraphSchema } from './project-sources.js';
const id = z.string().trim().min(1).max(500);
export const shopifyIntegrationScopeSchema = z.strictObject({ organizationId: id, storeConnectionId: id });
export const shopifyIntegrationPropertiesSchema = shopifyIntegrationScopeSchema.extend({
    projectSetupUrl: z.url().optional(),
    projects: z.array(z.strictObject({ projectId: id, name: z.string(), isDefault: z.boolean() })),
    properties: z.array(z.strictObject({ connectionId: id, property: z.string(), label: z.string() })),
    relationships: projectSourcesGraphSchema.shape.relationships,
});
export const shopifyIntegrationCommandSchema = z.discriminatedUnion('operation', [
    z
        .strictObject({
        operation: z.literal('save-link'),
        setupId: z.string().uuid().optional(),
        projectId: id,
        sourceConnectionId: id,
        expectedRevision: z.number().int().nonnegative(),
        expectedRelationshipId: id.nullable(),
    })
        .refine((input) => input.expectedRevision === 0 ? input.expectedRelationshipId === null : input.expectedRelationshipId !== null, { message: 'Expected relationship identity must match its revision' }),
    z.strictObject({
        operation: z.literal('remove-link'),
        projectId: id,
        relationshipId: id,
        expectedRevision: z.number().int().positive(),
    }),
]);
/** Inputs intentionally omit organization/channel; authenticated adapters supply them. */
export const shopifyIntegrationStatusInputSchema = z.strictObject({
    projectId: z.string().min(1),
    relationshipId: z.string().min(1),
});
export const shopifyIntegrationVoteInputSchema = z.strictObject({
    provider: z.string().min(1).max(255),
    voted: z.boolean(),
});
export const shopifyIntegrationSetupInputSchema = z.discriminatedUnion('operation', [
    z.strictObject({ operation: z.literal('start') }),
    z.strictObject({ operation: z.literal('read'), setupId: z.string().uuid() }),
    z.strictObject({ operation: z.literal('discover'), setupId: z.string().uuid() }),
    z.strictObject({ operation: z.literal('select'), setupId: z.string().uuid(), externalResourceId: z.string().min(1) }),
]);
export const shopifyIntegrationSetupResponseSchema = z.discriminatedUnion('operation', [
    z.strictObject({
        operation: z.literal('start'),
        setupId: z.string().uuid(),
        expiresAt: z.string(),
        handoffUrl: z.url(),
    }),
    z.strictObject({
        operation: z.literal('read'),
        setupId: z.string().uuid(),
        stage: z.string(),
        expiresAt: z.string(),
        connectionId: z.string().nullable(),
        selectedResourceId: z.string().nullable().optional(),
    }),
    z.strictObject({
        operation: z.literal('discover'),
        resources: z.array(z.object({ externalResourceId: z.string(), displayName: z.string() }).passthrough()),
    }),
    z.strictObject({ operation: z.literal('select'), connectionId: z.string().min(1) }),
]);
//# sourceMappingURL=shopify-integration-properties.js.map